import clsx from 'clsx';
import React from 'react';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import images from 'containers/Download/images';

import { useStyles, Theme } from './styles';

const Error = () => {
	const backgroundImage = React.useMemo(() => images.getNewImage(), []);
	const classes = useStyles({ backgroundImage });

	const theme = Theme();
	const isMobileVersion = useMediaQuery(theme.breakpoints.down('xs'));

	return (
		<Container className={classes.container} fixed>
			<Card className={clsx({ [classes.cardWrapperMobile]: isMobileVersion })}>
				<CardContent className={clsx(classes.card, { [classes.cardMobile]: isMobileVersion })}>
					<img src={`${process.env.PUBLIC_URL}/logo.svg`} className={classes.galleriesLogo} alt="Galleries" />
					<Typography variant="subtitle1" className={classes.subtitle}>
						Sorry, this content is not available anymore
					</Typography>
					<Typography variant="body2">The link you were provided with has expired. Try asking the sender for a new one.</Typography>
				</CardContent>
			</Card>
		</Container>
	);
};

export default React.memo(Error);
